import { throttle, takeLeading, put } from 'redux-saga/effects';

import HospitalAPI from 'lib/api/HospitalAPI';
import createRequestSaga from 'store/helpers/createRequestSaga';
import { openSnackbar } from 'features/snackbar';
import {
  GET_PATIENT_LIST,
  GET_PATIENT_SUMMARY_LIST,
  GET_NO_DOCTOR_PATIENT_LIST,
  ASSIGN_DOCTOR,
  UPDATE_PATIENT_PROFILE,
  SEND_REGISTER_REQUEST,
  GET_PATIENT_DETAIL,
} from '.';

const getPatientListSaga = createRequestSaga(
  GET_PATIENT_LIST,
  HospitalAPI.getPatientList,
);
const getPatientSummaryListSaga = createRequestSaga(
  GET_PATIENT_SUMMARY_LIST,
  HospitalAPI.getPatientList,
);
const getPatientDetailSaga = createRequestSaga(
  GET_PATIENT_DETAIL,
  HospitalAPI.getPatientDetail,
);
const getNoDoctorPatientListSaga = createRequestSaga(
  GET_NO_DOCTOR_PATIENT_LIST,
  HospitalAPI.getPatientList,
);
const assignDoctorSaga = createRequestSaga(
  ASSIGN_DOCTOR,
  HospitalAPI.updatePatientProfile,
  function* () {
    yield put(openSnackbar('지정 되었습니다'));
  },
);
const updatePatientProfileSaga = createRequestSaga(
  UPDATE_PATIENT_PROFILE,
  HospitalAPI.updatePatientProfile,
  function* () {
    yield put(openSnackbar('수정 되었습니다'));
  },
);
const sendRegisterRequestSaga = createRequestSaga(
  SEND_REGISTER_REQUEST,
  HospitalAPI.sendRegisterToPatient,
  function* () {
    yield put(openSnackbar('전송되었습니다'));
  },
);

export default function* patientsSaga() {
  yield throttle(1000, GET_PATIENT_LIST, getPatientListSaga);
  yield throttle(1000, GET_PATIENT_SUMMARY_LIST, getPatientSummaryListSaga);
  yield throttle(1000, GET_NO_DOCTOR_PATIENT_LIST, getNoDoctorPatientListSaga);
  yield throttle(1000, GET_PATIENT_DETAIL, getPatientDetailSaga);
  yield takeLeading(ASSIGN_DOCTOR, assignDoctorSaga);
  yield takeLeading(UPDATE_PATIENT_PROFILE, updatePatientProfileSaga);
  yield takeLeading(SEND_REGISTER_REQUEST, sendRegisterRequestSaga);
}
